<template>
  <!-- 弹窗蒙板 -->
  <div
    v-if="isShow"
    ref="dialogMock"
    class="confirm-mock"
    @click="clickMock"
  >
    <!--弹窗窗体  -->
    <div
      ref="coDialog"
      class="confirm-dialog"
      :style="{marginLeft: left + 'px',marginTop: top + 'px'}"
    >
      <!-- 弹窗标题 -->
      <div class="confirm-title">
        <!-- 标题插槽 -->
        <slot name="title">
          <span>{{ $t(title) }}</span>
        </slot>
        <!-- 关闭图标 -->
        <span
          v-show="isClose"
          class="i-close"
          @click="close"
        >
          <svg class="close-svg">
            <use xlink:href="#close" />
          </svg>
        </span>
      </div>
      <!-- 弹窗内容 -->
      <div
        class="confirm-content"
        :style="{width: width + 'px',height: height + 'px'}"
      >
        <!-- 内容插槽 -->
        <slot name="content" />
        <slot />
      </div>
      <!-- 弹窗底部 -->
      <div
        v-if="showFooter"
        class="clearfix"
      >
        <slot name="button">
          <div :class="[footClass? footClass:'confirm-footer']">
            <!-- 弹窗按钮组 -->
            <button
              v-if="isCancelLeft"
              class="btn c-btn mr-12"
              @click="cancel"
            >
              {{ $t(cancelBtn) }}
            </button>
            <button
              class="btn s-btn"
              :class="{'mr-12':!isCancelLeft}"
              @click="sure"
            >
              {{ $t(sureBtn) }}
            </button>
            <button
              v-if="!isCancelLeft"
              class="btn c-btn"
              @click="cancel"
            >
              {{ $t(cancelBtn) }}
            </button>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { // 定制标题
      type: String,
      default: '',
    },
    content: { // 定制内容
      type: String,
      default: '',
    },
    sureBtn: { // 确认按钮内容
      type: String,
      default: '确认',
    },
    cancelBtn: { // 取消按钮内容
      type: String,
      default: '取消',
    },
    value: { // 对话框显隐
      type: Boolean,
      default: false,
    },
    iconName: { // 图标名
      type: String,
      default: '#warn',
    },
    isClose: { // 关闭图标显隐
      type: Boolean,
      default: true,
    },
    isIcon: { // 是否显示图标
      type: Boolean,
      default: true,
    },
    height: { // content高度
      type: String,
      default: '',
    },
    width: { // content宽度
      type: String,
      default: '',
    },
    isCancelLeft: { // 是否显示在左侧
      type: Boolean,
      default: true,
    },
    footClass: {
      type: String,
      default: '',
    },
    showFooter: { // 显隐
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      left: 0, // margin-left 居中用
      top: 0, // margin-top 居中用
      isShow: false, // 显隐

    }
  },
  watch: {
    value(n, o) {
      this.isShow = n
      if (n) { // show dialog
        this.$nextTick(() => {
          this.setPosition()
        })
      }
    },
    isShow(n, o) {
      this.$emit('input', n)
    },
  },
  created() {
    this.isShow = this.value
  },
  mounted() {
    this.$nextTick(() => {
      this.setPosition()
    })
  },
  methods: {
    /**
    * 点击蒙层
    */
    clickMock() {
      this.$emit('clickMock')
    },
    /**
    * 关闭弹框
    */
    close() {
      this.isShow = false
      this.$emit('close')
    },
    /**
    * 取消事件
    */
    cancel() {
      this.isShow = false
      this.$emit('cancel')
    },
    /**
    * 确认事件
    */
    sure() {
      this.isShow = false
      this.$emit('sure')
    },
    /**
    * 设置弹框居中
    */
    setPosition() {
      if (!this.$refs.coDialog) return
      const coDialogWidth = this.$refs.coDialog.offsetWidth // 获取弹框宽度
      const coDialogHeight = this.$refs.coDialog.offsetHeight
      // console.log(coDialogWidth, coDialogHeight)
      this.left = -coDialogWidth / 2 // 设置居中
      this.top = -coDialogHeight / 2 // 设置居中
    },
  },
}
</script>
<style lang="less" scoped>

@import '~less/dialog.less';
.confirm-mock {
  background-color: rgba(127, 127, 127, .5)
}
</style>
